import React from 'react';
import imageWebp from '@iso/assets/images/ismoyo-logo-text-small.webp';
import imagePng from '@iso/assets/images/ismoyo-logo-text-small.png';

export default ({ width, height }) => (
  <picture>
    <source srcSet={imageWebp} type="image/webp" />
    <img src={imagePng} alt="ismoyo-logo" width={width} height={height} />
  </picture>
);
